import { Button, Color, Flex, Icon, SectionMessage, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export const BillRefusedInfo = (): ReactElement => {
  const { t } = useTranslation()

  const handleLearnMoreClick = useCallback(() => {
    const url = t('receipts.modal.reject_e_invoice_learn_more_url')
    window.open(url, '_blank', 'noopener,noreferrer')
  }, [t])

  return (
    <>
      <SectionMessage variant="info" showIcon={false}>
        <Flex alignItems="center" gap={Spacing.S12}>
          <Icon icon="info" size="lg" color={Color.Black} />
          <Text>{t('bill.view.form.refused_info')}</Text>
          <Button variant="onColor" color="accent" onClick={handleLearnMoreClick} iconRight="chevronRight" size="sm">
            {t('bill.view.form.refuse.learn_more')}
          </Button>
        </Flex>
      </SectionMessage>
      <Space />
    </>
  )
}
